module.exports = __webpack_public_path__ + "345d7a3e1dc142af50ef8c28570529e8.jpg";